import { Component, OnInit } from '@angular/core';
import { TypeDocumentProduitCrm } from 'src/app/parametrage/core/model/produitCrm/type-document-produitCrm';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ProduitCrmService } from 'src/app/parametrage/core/service/produit-crm.service';

@Component({
  selector: "app-add-type-document-produit-crm",
  templateUrl: "./add-type-document-produit-crm.component.html",
  styleUrls: ["./add-type-document-produit-crm.component.scss"]
})
export class AddTypeDocumentProduitCrmComponent implements OnInit {
  typeDocumentProduitCrm: TypeDocumentProduitCrm;
  form: FormGroup;
  pressButton: Boolean = false;
  submitted = false;
  errorMessage: string;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _produitCrmService: ProduitCrmService) {}

  ngOnInit() {
    this.form = this.createForm(this.typeDocumentProduitCrm);
  }

  createForm(data: TypeDocumentProduitCrm) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        code: [
          data ? data.code : "",
          Validators.compose([Validators.required])
        ],
        libelle: [data ? data.libelle : ""]
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        code: ["", Validators.compose([Validators.required])],
        libelle: ["", Validators.compose([Validators.required])]
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    this.findInvalidControls();
    if (this.form.invalid) {
      return;
    }
    if (!this.typeDocumentProduitCrm) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    this._produitCrmService
      .addTypeDocumentProduitCrm(this.form.value)
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
          this.pressButton = false;
        }
      );
  }

  updateData() {
    this._produitCrmService
      .updateTypeDocumentProduitCrm(
        this.typeDocumentProduitCrm.id,
        this.form.value
      )
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          if (error && error.error && error.status == 409) {
            this.errorMessage = error.error.message;
          }
          this.pressButton = false;
        }
      );
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid);
  }
}
